var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.itemEditable)?_c('v-text-field',{staticClass:"quantity d-inline-flex",attrs:{"value":_vm.getItemKey,"type":"number","dense":"","hide-spin-buttons":""},on:{"change":(value) => _vm.$emit('onUpdatePrice', { value, item: _vm.item })}}):_c('span',{class:[
      'action-icon editable_edge parameter',
      { proccessed: !_vm.editAble },
    ],on:{"click":function($event){return _vm.$emit('onEditFieldStatus', { item: _vm.item, status: true, field: null });}}},[_vm._v(" "+_vm._s(_vm.formatPrice(_vm.getItemKey))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }